import { render, staticRenderFns } from "./bulkImport.vue?vue&type=template&id=ddbde10a&scoped=true"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"
import style0 from "./bulkImport.vue?vue&type=style&index=0&id=ddbde10a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbde10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbde10a')) {
      api.createRecord('ddbde10a', component.options)
    } else {
      api.reload('ddbde10a', component.options)
    }
    module.hot.accept("./bulkImport.vue?vue&type=template&id=ddbde10a&scoped=true", function () {
      api.rerender('ddbde10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/components/bulkImport.vue"
export default component.exports